type InvoiceRecord = {
  id: string;
  number: string | null;
  amount_due: number;
  amount_paid: number;
  amount_remaining: number;
  currency: string;
  status: 'paid' | 'open' | 'draft' | 'void' | 'uncollectible';
  company_name: string | null;
  issued_at: string;
  paid_at: string | null;
  billing_period_start: string | null;
  billing_period_end: string | null;
  hosted_invoice_url: string | null;
  download_pdf_url: string;
  invoice_pdf: string | null;
};

const allInvoices: InvoiceRecord[] = [
  {
    id: 'inv-1',
    number: 'INV-1001',
    amount_due: 500,
    amount_paid: 500,
    amount_remaining: 0,
    currency: 'USD',
    status: 'paid',
    company_name: 'Acme GmbH',
    issued_at: '2026-02-09T12:00:00+00:00',
    paid_at: '2026-02-09T12:01:00+00:00',
    billing_period_start: '2026-02-09T00:00:00+00:00',
    billing_period_end: '2026-03-09T00:00:00+00:00',
    hosted_invoice_url: 'https://pay.stripe.com/invoice/mock',
    download_pdf_url: '/api/v1/customer/invoices/inv-1/pdf',
    invoice_pdf: 'https://files.stripe.com/links/mock',
  },
  {
    id: 'inv-2',
    number: 'INV-1000',
    amount_due: 1299,
    amount_paid: 0,
    amount_remaining: 1299,
    currency: 'USD',
    status: 'open',
    company_name: 'Acme GmbH',
    issued_at: '2026-01-09T12:00:00+00:00',
    paid_at: null,
    billing_period_start: '2026-01-09T00:00:00+00:00',
    billing_period_end: '2026-02-09T00:00:00+00:00',
    hosted_invoice_url: 'https://pay.stripe.com/invoice/mock2',
    download_pdf_url: '/api/v1/customer/invoices/inv-2/pdf',
    invoice_pdf: null,
  },
];

export const customerInvoiceOperations = {
  listInvoices: (params?: { limit?: number | string; cursor?: string }) => {
    const limitRaw = params?.limit;
    const limit = typeof limitRaw === 'number' ? limitRaw : typeof limitRaw === 'string' ? Number(limitRaw) : 20;
    const safeLimit = Number.isFinite(limit) ? Math.max(1, Math.min(100, limit)) : 20;
    const cursor = params?.cursor ?? null;
    const offset = cursor ? Number(cursor) || 0 : 0;
    const slice = allInvoices.slice(offset, offset + safeLimit);
    const nextOffset = offset + slice.length;
    const hasMore = nextOffset < allInvoices.length;

    return {
      data: slice,
      meta: {
        per_page: safeLimit,
        next_cursor: hasMore ? String(nextOffset) : null,
        prev_cursor: offset > 0 ? String(Math.max(0, offset - safeLimit)) : null,
        has_more: hasMore,
      },
      jsonapi: { version: '1.0' },
    };
  },
};

